import { motion } from "framer-motion";
import { Mail, Globe } from "lucide-react";
import { MaskLines, Rise, SlideShell, DashMark, Kicker } from "@/deck/ui";

export default function Closing({ go }) {
  return (
    <div className="relative min-h-full lg:h-full">
      <motion.img
        src="/assets/orb.jpg"
        alt=""
        initial={{ opacity: 0, scale: 1.15 }}
        animate={{ opacity: 0.35, scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="pointer-events-none absolute right-[-10%] top-1/2 hidden h-[120%] -translate-y-1/2 object-cover [mask-image:radial-gradient(circle,black_30%,transparent_65%)] lg:block"
      />
      <SlideShell testId="closing-slide" className="justify-center">
        <Rise><Kicker index="08">Why Dash, why now</Kicker></Rise>
        <MaskLines
          testId="closing-statement"
          lines={["Every building will", "have an assistant.", "In Indonesia, it's Dash."]}
          accentIndex={2}
          className="mt-6 max-w-5xl text-[2.6rem] font-extrabold leading-[0.95] tracking-[-0.04em] sm:text-6xl lg:text-[5.6rem]"
        />
        <Rise delay={0.7} className="mt-8 max-w-2xl">
          <p className="text-base leading-relaxed text-zinc-300 lg:text-lg">
            Personal AI assistants are becoming the new interface for everything. Dash AI brings that interface to
            every meter, every tenant and every rupiah in Indonesia's buildings and commercial areas.
          </p>
        </Rise>
        <Rise delay={0.9} className="mt-10 flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.03] py-2 pl-2 pr-5">
            <DashMark className="h-8 w-auto" />
            <span className="font-display text-base font-semibold text-zinc-50">Thank you.</span>
          </div>
          <a href="https://dash.tokenku.app" target="_blank" rel="noreferrer" data-testid="closing-website-link" className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2.5 text-sm text-zinc-200 transition-colors hover:border-[var(--dash)] hover:text-[var(--dash)]">
            <Globe size={15} /> dash.tokenku.app
          </a>
          <a href="mailto:tokenku@powermanager.id" data-testid="closing-email-link" className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2.5 text-sm text-zinc-200 transition-colors hover:border-[var(--dash)] hover:text-[var(--dash)]">
            <Mail size={15} /> tokenku@powermanager.id
          </a>
          <button onClick={() => go(0)} data-testid="closing-restart-button" className="rounded-full px-4 py-2.5 font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-400 transition-colors hover:text-zinc-100">
            ↺ Back to start
          </button>
        </Rise>
      </SlideShell>
    </div>
  );
}
